import React from 'react';
import { UNIT } from '../../../settings/settings';
import { coalesce } from '../../../utils/utils';
import CurrencyInput from '../CurrencyInput/CurrencyInput';
import PercentageInput from '../PercentageInput/PercentageInput';
import SharesInput from '../SharesInput/SharesInput';
import InputButton, { InputButtonProps } from './InputButton/InputButton';
import './MultiInput.scss';
import { defaultAllowedUnits } from './types';

const INPUT_COMPONENT_MAP = {
  [UNIT.ALL_SHARES]: SharesInput,
  [UNIT.DOLLARS]: CurrencyInput,
  [UNIT.PERCENT]: PercentageInput,
  [UNIT.SHARES]: SharesInput,
};

export interface MultiInputProps extends InputButtonProps {
  ariaLabel?: string;
  inputID?: string;
  onInputChange;
}

const MultiInput: React.FC<MultiInputProps> = ({
  allowedUnits = defaultAllowedUnits,
  applyBranding = false,
  ariaLabel,
  className,
  disabled = false,
  inputID,
  onInputChange,
  onUnitChange,
  selectedInput = UNIT.DOLLARS,
  ...rest
}) => {
  const SelectedInput = INPUT_COMPONENT_MAP[selectedInput];
  return (
    <div className={`multi-input-container ${coalesce(className, '')}`}>
      <SelectedInput
        {...rest}
        displayInline
        disabled={disabled}
        id={inputID}
        onChange={onInputChange}
      />
      <InputButton
        allowedUnits={allowedUnits}
        applyBranding={applyBranding}
        disabled={disabled}
        selectedInput={disabled ? UNIT.SHARES : selectedInput}
        onUnitChange={onUnitChange}
      />
    </div>
  );
};

export default MultiInput;
